import Image from 'common/components/image'

export interface Props {
  name: string
  style?: React.CSSProperties
}

export const CepIcon = ({ name, style = {} }: Props) => {
  const iconsMap: Record<string, JSX.Element> = {
    braze: <Image src="/images/cepIntegration/braze.svg" alt="braze" />,
    adobe: <Image src="/images/cepIntegration/adobe.svg" alt="adobe" />,
    cheetah: <Image src="/images/cepIntegration/marigold.svg" alt="marigold" />,
    liveclicker: (
      <Image src="/images/cepIntegration/marigold.svg" alt="marigold" />
    ),
    adobe_campaign_standard: (
      <Image src="/images/cepIntegration/adobe.svg" alt="adobe" />
    ),
    adobe_campaign_classic: (
      <Image src="/images/cepIntegration/adobe.svg" alt="adobe" />
    ),
    ajo: <Image src="/images/cepIntegration/adobe.svg" alt="adobe" />,
    leanplum: (
      <Image src="/images/cepIntegration/leanplum.svg" alt="leanplum" />
    ),
    ibm: <Image src="/images/cepIntegration/ibm.svg" alt="ibm" />,
    message_gears: (
      <Image
        src="/images/cepIntegration/messagegears.svg"
        alt="message_gears"
      />
    ),
    bloomreach: (
      <Image src="/images/cepIntegration/bloomreach.svg" alt="bloomreach" />
    ),
    cordial: <Image src="/images/cepIntegration/cordial.svg" alt="cordial" />,
    emarsys: <Image src="/images/cepIntegration/emarsys.svg" alt="emarsys" />,
    epsilon: <Image src="/images/cepIntegration/epsilon.svg" alt="epsilon" />,
    optimizely: (
      <Image src="/images/cepIntegration/optimizely.svg" alt="optimizely" />
    ),
    movable_ink: (
      <Image src="/images/cepIntegration/movableink.svg" alt="movable_ink" />
    ),
    sailthru: (
      <Image src="/images/cepIntegration/sailthru.svg" alt="sailthru" />
    ),
    iterable: (
      <Image src="/images/cepIntegration/iterable.svg" alt="iterable" />
    ),
    responsys: (
      <Image src="/images/cepIntegration/oracle.svg" alt="responsys" />
    ),
    moengage: (
      <Image src="/images/cepIntegration/moengage.svg" alt="moengage" />
    ),
    sfmcv2: <Image src="/images/cepIntegration/sfmcv2.svg" alt="sfmcv2" />,
    facebook: (
      <Image src="/images/cepIntegration/facebook.svg" alt="facebook" />
    ),
    airship: <Image src="/images/cepIntegration/airship.svg" alt="airship" />,
    acoustic: (
      <Image src="/images/cepIntegration/acoustic.svg" alt="acoustic" />
    ),
    marigold: (
      <Image src="/images/cepIntegration/marigold.svg" alt="marigold" />
    ),
    mapp: <Image src="/images/cepIntegration/mapp.svg" alt="mapp" />,
    none: <Image src="/images/cepIntegration/none.svg" alt="none" />,
  }

  return (
    <div style={style}>
      {iconsMap[name] || (
        <Image src="/images/cepIntegration/none.svg" alt="none" />
      )}
    </div>
  )
}

export default CepIcon
